import { Business as p, Cities as r, Group as u, User as c, Organization as A } from "@partoohub/api-client";
const g = (i) => {
  const n = new p(i), s = new r(i), t = new u(i), e = new c(i), o = new A(i);
  return {
    business: n,
    cities: s,
    groups: t,
    user: e,
    organization: o
  };
};
export {
  g as buildApiResources
};
